<script>
export default {
    data() {
        return {
            logoutFlg: false
        }
    },
    computed: {
        userInfoJson: function(){
            var userInfoJson = document.getElementById("userinfo").value;
            if (userInfoJson) {
                var userInfo = JSON.parse(userInfoJson);
            }
            var mkdbId = userInfo.mkdb_id;
        },
        isLogout: function(){
            return this.logoutFlg;
        }
    },
    mounted: function(){
    },
    created: function(){
    },
    methods: {
        logoutView: function(){
            this.logoutFlg = true;
        },
        logoutAllUrl: function(){
            var logoutAll = 'https://auth2.jleague.jp/logout-all.html';
            var logoutUrl = 'https://login2.jleague.jp/oauth/authorize?client_id=jleague-logout-client&redirect_uri=' + encodeURIComponent(logoutAll);
            logoutUrl = logoutUrl + '%23mkdb_id=' + mkdb_id + '&response_type=token';
            location.href = logoutUrl;
        },
        favoritePlayerUrl: function(){
            var DEFAULT_CLIENT_ID = "jleague-auth-home-redirect-client";
            var DEFAULT_REDIRECT_URI = "https://login2.jleague.jp/home";

            var originalCilentId = DEFAULT_CLIENT_ID;
            var originalRedirectUri = DEFAULT_REDIRECT_URI;
            var redirecturl = document.getElementById("redirecturl").value;

            if (typeof jleagueClient !== 'undefined') {
                originalCilentId = jleagueClient.client_id;
                if (redirecturl) {
                    originalRedirectUri = redirecturl;
                } else if (typeof jleagueClient.redirect_url !== 'undefined' && jleagueClient.redirect_url !== '') {
                    originalRedirectUri = jleagueClient.redirect_url;
                }
            }

            let favoritePlayer = 'https://auth2.jleague.jp/favorite-player.html';
            let favoritePlayerUrl = 'https://login2.jleague.jp/oauth/authorize?client_id=jleague-logout-client&redirect_uri=' + encodeURIComponent(favoritePlayer);
            favoritePlayerUrl = favoritePlayerUrl + '%23original_client_id=' + originalCilentId + '%26original_redirect_uri=' + originalRedirectUri +'&response_type=token';
            
            location.href = favoritePlayerUrl;
        },
        back: function(){
            this.logoutFlg = false;
        }
    }
}
</script>
